'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _I18n2.default.lang !== 'en' && !_I18n2.default.langEnabled && !_I18n2.default.publicPage ? 'en' : _I18n2.default.lang;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.433/js/utils/getLang.js
// module id = 112
// module chunks = 3 4 5